import React, { Component } from 'react';
import { Button, message } from 'antd';
import FilterBasic from '../../basicElement/FilterBasic';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import TableC from '../../basicElement/TableC';
import moment from 'moment';

const yearFormat = 'YYYY';
let year = moment().format(yearFormat);
const monthMap = new Map([['01', '1'], ['02', '2'], ['03', '3'], ['04', '4'], ['05', '5'], ['06', '6'], ['07', '7'], ['08', '8'], ['09', '9'], ['10', '10'], ['11', '11'], ['12', '12']]);

class Filter extends Component {
    handleChange = (params, key) => {
        if (key === 'startDate') {
            year = moment(params.startDate).format(yearFormat);
        } else {
            year = moment(params.endDate).format(yearFormat);
        }
        params.startDate = `${year}-01`;
        params.endDate = `${year}-12`;
        this.props.onChange(params, key);
    }

    render() {
        const { businessList, ...rest } = this.props;
        const businessOption = businessList.map(i => ({ value: i.typeConfigureId, label: i.typeValue }));
        const filters = [{
            name: '统计时间',
            key: 'startDate',
            type: 'monthPicker',
            typeProperty: {
                allowClear: false,
            }
        }, {
            name: '~',
            key: 'endDate',
            type: 'monthPicker',
            typeProperty: {
                allowClear: false,
            }
        }, {
            name: '领域leader',
            key: 'leaderUser',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyword',
                style: {width: 140},
                placeholder: '输入姓名/工号检索',
                params: {limit: 20},
                url: API_URL.user.queryLeaderList,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }
            }
        }, {
            name: '业务线',
            key: 'lineOfBusiness',
            type: 'select',
            typeProperty: {
                list: businessOption,
            }
        }];
        return (
            <FilterBasic filters={filters} {...rest} onChange={this.handleChange} />
        )
    }
}

class CenterPlanStartNum extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            businessList: [],
            loading: false,
            sortParams: {},
            searchParams: {},
            curParams: {},
            pagination: {
                pageSize: 10,
                current: 1,
            },
        }
    }

    componentDidMount() {
        year = moment().format(yearFormat);
        this.queryEffectiveDate();
        this.queryWithLevelByParams();
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => this.setState({ businessList: res.typeConfigureList || [] }));
    }

    queryEffectiveDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.home.queryEffectiveDate,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { trueMonth, trueYear } = res;
            const { searchParams } = this.state;
            searchParams.startDate = `${trueYear}-01`;
            searchParams.endDate = `${trueYear}-12`;
            this.setState({
                searchParams,
                curParams: {...searchParams},
            }, () => {
                this.loadData();
            });
        });
    }

    loadData = () => {
        const { sortParams, curParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.dashboard.querySitePlanAndActualStart,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...curParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = () => {
        const { pagination, searchParams } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            curParams: {
                ...searchParams,
            },
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { sortParams, curParams } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.dashboard.exportSitePlanAndActualStart,
            data: {
                ...sortParams,
                ...curParams,
                offset: 1,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
            },
        };
        $.sendRequest(options);
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    getColumns = () => {
        const columns = [{
            title: 'JDE主项目号',
            dataIndex: 'jdeMainCode',
            key: 'jdeMainCode',
            fixed: 'left',
            width: 120,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            fixed: 'left',
            width: 160,
        }, {
            title: '项目阶段',
            dataIndex: 'investigationStageNames',
            key: 'investigationStageNames',
            width: 160,
        }, {
            title: '项目计划结束时间',
            dataIndex: 'investigationPlanEndTime',
            key: 'investigationPlanEndTime',
            width: 120,
        }, {
            title: '业务线',
            dataIndex: 'lineName',
            key: 'lineName',
            width: 80,
        }, {
            title: '执行业务线二级分类',
            dataIndex: 'secondLineName',
            key: 'secondLineName',
            width: 120,
        }, {
            title: '项目分类',
            dataIndex: 'investigationTypeName',
            key: 'investigationTypeName',
            width: 100,
        }, {
            title: '项目领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            width: 100,
        }, {
            title: '疾病',
            dataIndex: 'diseaseName',
            key: 'diseaseName',
            width: 100,
        }, {
            title: '领域leader',
            dataIndex: 'invAreaLeaderNameCode',
            key: 'invAreaLeaderNameCode',
            width: 120,
        }, {
            title: '项目经理工号',
            dataIndex: 'mainPmCode',
            key: 'mainPmCode',
            width: 100,
        }, {
            title: '项目经理姓名',
            dataIndex: 'mainPmName',
            key: 'mainPmName',
            width: 100,
        }, {
            title: '区域',
            dataIndex: 'areaName',
            key: 'areaName',
            width: 80,
        }, {
            title: '城市',
            dataIndex: 'cityName',
            key: 'cityName',
            width: 80,
        }, {
            title: '中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            width: 160,
        }, {
            title: '科室名称',
            dataIndex: 'hospitalDepartmentName',
            key: 'hospitalDepartmentName',
            width: 160,
        }, {
            title: '医院主管姓名',
            dataIndex: 'directorUserCompellation',
            key: 'directorUserCompellation',
            width: 100,
        }, {
            title: '医院主管工号',
            dataIndex: 'directorEmployeeCode',
            key: 'directorEmployeeCode',
            width: 100,
        }, {
            title: '类型',
            dataIndex: 'type',
            key: 'type',
            width: 80,
        }];
        for (let [key, value] of monthMap) {
            columns.push({
                title: `${year}-${key}`,
                key: `month${value}`,
                dataIndex: `month${value}`,
                width: 70,
                render: (text, row) =>{
                    const actualAmount = row['actualAmount'+value];
                    const planAmount = row['planAmount'+value];
                    return planAmount + '/' + actualAmount
                }
            });
        }
        columns.push({
            title: 'Q1计划启动数',
            dataIndex: 'q1PlanAmount',
            key: 'q1PlanAmount',
            width: 100,
        }, {
            title: 'Q2计划启动数',
            dataIndex: 'q2PlanAmount',
            key: 'q2PlanAmount',
            width: 100,
        }, {
            title: 'Q3计划启动数',
            dataIndex: 'q3PlanAmount',
            key: 'q3PlanAmount',
            width: 100,
        }, {
            title: 'Q4计划启动数',
            dataIndex: 'q4PlanAmount',
            key: 'q4PlanAmount',
            width: 100,
        }, {
            title: 'Q1累计启动数',
            dataIndex: 'q1ActualAmount',
            key: 'q1ActualAmount',
            width: 100,
        }, {
            title: 'Q2累计启动数',
            dataIndex: 'q2ActualAmount',
            key: 'q2ActualAmount',
            width: 100,
        }, {
            title: 'Q3累计启动数',
            dataIndex: 'q3ActualAmount',
            key: 'q3ActualAmount',
            width: 100,
        }, {
            title: 'Q4累计启动数',
            dataIndex: 'q4ActualAmount',
            key: 'q4ActualAmount',
            width: 100,
        })
        return columns;
    }
    
    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { exportable } = this.props;
        const { data, loading, pagination, searchParams, sortParams, businessList } = this.state;
        return (
            <div>
                <div className="reportTitle">{this.props.title}</div>
                <Filter
                    search={this.search}
                    params={searchParams}
                    businessList={businessList}
                    onChange={this.handleFilterChange}
                    buttons={[
                        <Button key="export" type="primary" onClick={this.export} style={{marginLeft: 8}}>导出</Button>
                    ]}
                />
                <div style={{marginTop: -20, marginBottom: 4, color: '#ffa500'}}>注：由于数据量过大，页面仅展示其中一个项目一个中心的数据，请导出后查看完整数据</div>
                <TableC
                    data={data}
                    loading={loading}
                    className="crcMonthInGroup"
                    sortParams={sortParams}
                    columns={this.getColumns()}
                    pagination={pagination}
                    onChange={this.handleTableChange}
                />
            </div>
        );
    }
}

export default CenterPlanStartNum;


// WEBPACK FOOTER //
// ./src/components/homePage/statement/centerPlanStartNum.js